export default import.meta.ROLLUP_FILE_URL_P8CRhISZ7u3PTPcc4w1xTQ